export default function useRandomBg(id: number): string {
  // num of placeholder classes used for bg
  const numOfClasses = 4;
  return `placeholder__bg-${(id % numOfClasses) + 1}`;
}